<template>
  <div>
    <b-field>
      <b-input
        placeholder="Cerca sales points..."
        type="search"
        icon="search"
        :disabled="$ajax.anyLoading"
        :loading="$ajax.anyLoading"
        @keyup.native.enter="getAsyncData"
        v-model.trim="search_term"
        autofocus
      ></b-input>
      <p class="control">
        <button
          class="button is-primary"
          :disabled="$ajax.anyLoading"
          v-on:click="getAsyncData"
        >
          Cerca
        </button>
      </p>
    </b-field>
  </div>
</template>
<script>
export default {
  name: "search-client",
  data() {
    return {
      search_term: "", // null writes null, tard js
      dataList: [],
    };
  },
  methods: {
    getAsyncData: function () {
      this.$ajax.request({
        address: `/salespoints/search/` + this.search_term,
        method: "GET",
        onSuccess: (response) => {
          this.dataList = [];
          response.data.forEach((item) => this.dataList.push(item));
          this.$emit("eventGotResults", this.dataList);
        },
      });
    },
  },
};
</script>
